let treeActions = require('../../actions/custom-order/filterable-tree');
let utils = require('../../actions/utils');

module.exports = {
    onSwitchSubTreeCollapse: [
        treeActions.switchSubTreeCollapse
    ],
    onSwitchSubTreeCollapseCustom: [
        treeActions.switchSubTreeCollapseCustom
    ],
    onFilter: [
        treeActions.setFilter
    ],
    initFilter: [
        treeActions.initFilter
    ],
    onShowSelectedOnly: [
        treeActions.setShowSelectedOnly
    ],
    onItemCheck: [
        treeActions.changeValue
    ]
};



// WEBPACK FOOTER //
// ./signals/custom-order/filterable-tree.js